<template>
  <aside class="menu is-hidden-mobile">
    <p class="menu-label">메인화면</p>
    <ul class="menu-list">
      <li>
        <router-link class="nav-link" :to="{name:'adminMainList'}"
                     :class="{ 'is-active': $route.path.indexOf('main') > -1}">배너
        </router-link>
      </li>
      <li>
        <router-link class="nav-link" :to="{name:'adminPopupList'}"
                     :class="{ 'is-active': $route.path.indexOf('popup') > -1}">팝업
        </router-link>
      </li>
    </ul>
    <p class="menu-label">미디어</p>
    <ul class="menu-list">
      <li>
        <router-link class="nav-link" to="/admin/column/list"
                     :class="{ 'is-active': $route.path.indexOf('column') > -1}">오늘하루 컬럼
        </router-link>
      </li>
      <li>
        <router-link class="nav-link" to="/admin/news/list"
                     :class="{ 'is-active': $route.path.indexOf('news') > -1}">보도자료
        </router-link>
      </li>
      <li>
        <router-link class="nav-link" to="/admin/case/list"
                     :class="{ 'is-active': $route.path.indexOf('case') > -1}">치료 케이스
        </router-link>
      </li>
      <li>
        <router-link class="nav-link" to="/admin/visitor/list"
                     :class="{ 'is-active': $route.path.indexOf('visitor') > -1}">특별한 방문
        </router-link>
      </li>
    </ul>
    <p class="menu-label">상담</p>
    <ul class="menu-list">
      <li>
        <router-link class="nav-link" to="/admin/counsel/list"
                     :class="{ 'is-active': $route.path.indexOf('counsel') > -1}">상담 신청
        </router-link>
      </li>
      <li>
        <router-link class="nav-link" to="/admin/model/list"
                     :class="{ 'is-active': $route.path.indexOf('model') > -1}">모델 지원
        </router-link>
      </li>
    </ul>
    <p class="menu-label">기타</p>
    <ul class="menu-list">
      <li>
        <router-link class="nav-link" :to="{name:'adminEventList'}"
                     :class="{ 'is-active': $route.path.indexOf('event') > -1}">이벤트
        </router-link>
      </li>
      <li>
        <router-link class="nav-link" to="/admin/privacy"
                     :class="{ 'is-active': $route.path.indexOf('privacy') > -1}">개인정보 취급방침
        </router-link>
      </li>
    </ul>
  </aside>

</template>

<script>
export default {
  name: 'Sidebar',
};
</script>

<style scoped>
  .menu-label {
    color: #8F99A3;
    letter-spacing: 1.3;
    font-weight: 700;
  }

  .menu-list a {
    color: #0F1D38;
    font-size: 14px;
    font-weight: 700;
  }

  .menu-list a:hover {
    background-color: transparent;
    color: #276cda;
  }

  .menu-list a.is-active {
    background-color: transparent;
    color: #276cda;
    font-weight: 700;
  }
</style>
